import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpErrorResponse,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
  } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthenticationExpiredInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .do(() => {
        },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 419) {
              window.location.reload();
            }
          }
        });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/interceptors/AuthenticationExpiredInterceptor.ts